module.exports = __webpack_public_path__ + "img/app_placeholder.2a110a52.png";